//product page faq toggle js
function toggleFAQ(button) {
          let faqItem = button.parentElement;
          let faqAnswer = faqItem.querySelector(".faq-answer");
          let icon = button.querySelector(".faq-icon");

          if (faqItem.classList.contains("open")) {
              faqItem.classList.remove("open");
              faqAnswer.style.display = "none";
              icon.textContent = "+";
          } else {
              // Close all FAQs first
              document.querySelectorAll(".faq-item").forEach(item => {
                  item.classList.remove("open");
                  item.querySelector(".faq-answer").style.display = "none";
                  item.querySelector(".faq-icon").textContent = "+";
              });

              // Open the clicked one
              faqItem.classList.add("open");
              faqAnswer.style.display = "block";
              icon.textContent = "−";
          }
      }


//Product page custom tab color change handling js
function toggleTab(element) {
    const isExpanded = element.getAttribute('aria-expanded') === 'true';
    element.setAttribute('aria-expanded', !isExpanded);
    if (!isExpanded) {
      element.classList.add('active');
    } else {
      element.classList.remove('active');
    }
  }

//product page media shocase as slider 
$(document).ready(function(){
  $('.product-media-container').slick({
    autoplay: true,
    dots: false,
    arrows: false,
    infinite: true,
    pauseOnHover: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,  // Start from the first slide
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: true, 
          centerPadding: "2%"
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "10%"
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "40px"  // Adjusted for better visibility on smaller screens
        }
      }
    ]
  });
});




//vertical slider text column
$(document).ready(function () {
  var currentIndex = 0;

  function updateSlider() {
    var slideHeight;

    if ($(window).width() <= 768) { // Mobile view
      slideHeight = $('.vertical-slide .column').outerHeight(true); // Get full height including margins
    } else { // Desktop view
      slideHeight = $('.vertical-slider-container').height(); // Full container height for desktop
    }

    $('.vertical-slider-wrapper').css({
      transform: 'translateY(' + (-currentIndex * slideHeight) + 'px)',
      transition: 'transform 0.4s ease-in-out' // Smooth transition
    });
  }

  $('.arrow-up').on('click', function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  });

  $('.arrow-down').on('click', function () {
    var totalSlides = $(window).width() <= 768 
      ? $('.vertical-slide .column').length 
      : $('.vertical-slide').length;

    if (currentIndex < totalSlides - 1) {
      currentIndex++;
      updateSlider();
    }
  });

  $(window).on('resize', function () {
    updateSlider(); // Recalculate positions on resize
  });

  updateSlider(); // Initial update
});




//logo chnage pages template wise
document.addEventListener('DOMContentLoaded', function () {
    // Get the logo element for the main header
    var mainLogo = document.querySelector('.logo img'); // Adjust the selector if necessary

    // Function to change the logo based on the template class
    function updateLogo(logoElement) {
        if (document.body.classList.contains('template-collection')) {
            logoElement.src = 'https://cdn.shopify.com/s/files/1/0661/2113/8345/files/Group.png?v=1724216247';
        } else if (document.body.classList.contains('template-product')) {
            logoElement.src = 'https://cdn.shopify.com/s/files/1/0661/2113/8345/files/Group.png?v=1724216247';
       
        } else if (document.body.classList.contains('template-page')) {
            logoElement.src = 'https://cdn.shopify.com/s/files/1/0661/2113/8345/files/Group.png?v=1724216247';
        } else if (document.body.classList.contains('template-list-collections')) {
            logoElement.src = 'https://cdn.shopify.com/s/files/1/0661/2113/8345/files/Group.png?v=1724216247';
        } else if (document.body.classList.contains('template-cart')) {
            logoElement.src = 'https://cdn.shopify.com/s/files/1/0661/2113/8345/files/Group.png?v=1724216247';
        } else if (document.body.classList.contains('template-article')) {
            logoElement.src = 'https://cdn.shopify.com/s/files/1/0661/2113/8345/files/Group.png?v=1724216247';
        } else if (document.body.classList.contains('template-blog')) {
            logoElement.src = 'https://cdn.shopify.com/s/files/1/0661/2113/8345/files/Group.png?v=1724216247';
        } else if (document.body.classList.contains('template-search')) {
            logoElement.src = 'https://cdn.shopify.com/s/files/1/0661/2113/8345/files/Group.png?v=1724216247';  
        } 
        else {
            logoElement.src = 'https://cdn.shopify.com/s/files/1/0661/2113/8345/files/logo.png?v=1717416759';
        }
    }

    // Initial update for the main logo
    updateLogo(mainLogo);

    // Function to handle the logo update based on sticky header state
    function handleStickyHeader() {
        var isStickyHeaderActive = document.body.classList.contains('header-appear');

        if (isStickyHeaderActive) {
            // If sticky header is active, set the logo to the default logo
            mainLogo.src = 'https://cdn.shopify.com/s/files/1/0661/2113/8345/files/logo.png?v=1717416759';
        } else {
            // If sticky header is not active, set the logo based on the page template
            updateLogo(mainLogo);
        }
    }

    // Listen for scroll events to detect when the sticky header is active
    window.addEventListener('scroll', handleStickyHeader);

    // Also check the sticky header status on page load in case the page starts scrolled down
    handleStickyHeader();
});


//scrollable card in collection page
$(document).ready(function(){
    $('.scrollable-cards-container').slick({
        autoplay: true,
        dots: false,
        arrows: false,
        infinite: true,
        pauseOnHover: false,
        centerMode: true,  // Enable centering
        centerPadding: "5%",  // Padding for larger screens
        slidesToShow: 3,  // Adjusted for larger screens
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    centerMode: true,
                    centerPadding: "5%",
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    centerPadding: "10%",
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,  // For mobile screens
                settings: {
                    slidesToShow: 1,
                    centerMode: true,  // Keep centering
                    centerPadding: "30px",  // Partial visibility on both sides
                    slidesToScroll: 1
                }
            }
        ]
    });
});




//this is for custom collection section remove shop all text to different
document.addEventListener("DOMContentLoaded", function() {
    // Select the specific section by ID and class
    const section = document.querySelector('.template-collection-custom-collection #shopify-section-template--17552699785385__featured_collection_QQF6xV');
    
    if (section) {
        // Select the link containing the "Shop All" text within this section
        const linkElement = section.querySelector('.section-heading__actions a');
        
        if (linkElement) {
            // Change the text content to "SHOP THE HOPPY KIT"
            linkElement.childNodes[0].nodeValue = "SHOP THE HOPPY KIT ";
        }
    }
});


//this is for tabs collection
  document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.nav-link');
    const tabPanes = document.querySelectorAll('.tab-pane');
    const dropdown = document.querySelector('.nav-tabs-dropdown');

    // Generate dropdown options based on tabs
    if (dropdown) {
      dropdown.innerHTML = Array.from(tabs).map(tab => {
        const tabId = tab.getAttribute('href').substring(1);
        const tabName = tab.textContent.trim();
        return `<option value="${tabId}">${tabName}</option>`;
      }).join('');
    }

    function updateTabFromDropdown(selectElement) {
      const selectedTabId = selectElement.value;
      const tabLink = document.querySelector('a[href="#' + selectedTabId + '"]');

      if (tabLink) {
        tabLink.click();
      }
    }

    // Handle tab clicks to update dropdown and tab content
    tabs.forEach(tab => {
      tab.addEventListener('click', function(event) {
        event.preventDefault();

        // Remove active class from all tabs and hide all tab panes
        tabs.forEach(item => item.classList.remove('active'));
        tabPanes.forEach(pane => pane.classList.remove('show', 'active'));

        // Add active class to the clicked tab
        tab.classList.add('active');

        // Show the corresponding tab pane
        const tabPane = document.querySelector(tab.getAttribute('href'));
        tabPane.classList.add('show', 'active');

        // Update dropdown selection
        if (dropdown) {
          dropdown.value = tab.getAttribute('href').substring(1);
        }
      });
    });

    // Attach event listener to dropdown
    if (dropdown) {
      dropdown.addEventListener('change', function() {
        updateTabFromDropdown(this);
      });
    }
  });

  function updateTabFromDropdown(selectElement) {
    const selectedTabId = selectElement.value;
    const tabLink = document.querySelector('a[href="#' + selectedTabId + '"]');

    if (tabLink) {
      tabLink.click();
    }
  }



